import React from "react";
import { Button, Chip } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import type { PaymentStatus } from "../types";

interface ActiveCircleActionsProps {
  circleId: string;
  paymentStatus: PaymentStatus;
  canWithdraw?: boolean;
  onViewDetails: (circleId: string) => void;
}

export const ActiveCircleActions: React.FC<ActiveCircleActionsProps> = ({
  circleId,
  paymentStatus,
  canWithdraw,
  onViewDetails,
}) => {
  if (paymentStatus.isPayee) {
    return (
      <Button
        size="small"
        variant={canWithdraw ? "contained" : "outlined"}
        color="secondary"
        disabled={!canWithdraw}
      >
        Withdraw
      </Button>
    );
  }

  if (paymentStatus.status === "Paid") {
    return (
      <Chip
        size="small"
        label="Paid"
        color="success"
        icon={<CheckCircleIcon fontSize="small" />}
        variant="outlined"
      />
    );
  }

  if (paymentStatus.status === "Processing") {
    return (
      <Chip
        size="small"
        label="Processing"
        color="info"
        variant="outlined"
      />
    );
  }

  if (paymentStatus.status === "Pending") {
    return (
      <Button
        size="small"
        variant="contained"
        color="primary"
        onClick={() => onViewDetails(circleId)}
      >
        Pay Now
      </Button>
    );
  }

  return null;
};

